export const POD_EVAL_WEBSOCKET_EVENTS = {
  MALPRACTICE_CHK: 'MALPRACTICE_CHK',
  MALPRACTICE_STATUS: 'MALPRACTICE_STATUS',
  NO_MALPRACTICE: 'NO MALPRACTICE',
  MALPRACTICE_DETECTED: 'MALPRACTICE DETECTED',
  EVALUATE: 'EVALUATE',
  XML: 'XML',
  CONFIGURATION: 'CONFIGURATION',
};

export const WEBSOCKET_CLOSE_REASONS = ['keepalive ping timeout'];

export const PROJECT_BASED_PROBLEM_TYPES = {
  PFE: 'PFE',
  PBE: 'PBE',
  PFS: 'PFS',
  PBT: 'PBT',
  PBD: 'PBD',
};
export const POD_HEALTH_CHECK_INTERVAL_IN_MILISECONDS = 30 * 1000;

export const MESSAGE_ON_SAVE_AND_CLOSE =
  'Closing tab. This might take a few seconds depending on your network connection.';

export default {
  POD_EVAL_WEBSOCKET_EVENTS,
};
